"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const Icon_1 = require("@material-ui/core/Icon");
const Typography_1 = require("@material-ui/core/Typography");
const react_i18next_1 = require("react-i18next");
const assets_1 = require("../config/assets");
const SuperBonusTagStyle_1 = require("./jss/SuperBonusTagStyle");
const SuperBonusTag = ({ onClick }) => {
    const classes = (0, SuperBonusTagStyle_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const icon = assets_1.assets.internalAssets.superBonusImg;
    const goToProgressPage = () => {
        if (onClick) {
            onClick();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, item: true, xs: 12, sm: 6, direction: "row", className: classes.superBonus, onClick: goToProgressPage }, { children: [icon && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ xs: 2 }, { children: (0, jsx_runtime_1.jsx)("img", { alt: "super bonus", src: icon, className: classes.star }) }))), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 9, justify: "center", className: classes.superBonusProgress }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", className: classes.superBonusProgressText }, { children: t('superBonus.progressTitle') })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ xs: 1 }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { children: "chevron_right" }) }))] })));
};
exports.default = SuperBonusTag;
//# sourceMappingURL=SuperBonusTag.js.map